import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIceHockey: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconIceHockey"><Path d="M22.25 9.39583C22.25 11.4094 17.6609 13.0417 12 13.0417C6.33908 13.0417 1.75 11.4094 1.75 9.39583M22.25 9.39583C22.25 7.3823 17.6609 5.75 12 5.75C6.33908 5.75 1.75 7.3823 1.75 9.39583M22.25 9.39583V14.6042C22.25 16.6177 17.6609 18.25 12 18.25C6.33908 18.25 1.75 16.6177 1.75 14.6042V9.39583" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconIceHockey;
